





















































import Vue from 'vue';
import { createNamespacedHelpers, mapState as mapRootState } from 'vuex';
import moment from 'moment';
import 'moment/locale/nb'; // Norwegian Bokmål locale
const { mapState, mapGetters } = createNamespacedHelpers('grievanceItem');
const grievanceFormGetters = createNamespacedHelpers('grievanceForm').mapGetters;
const mapCustomLabelsState = createNamespacedHelpers('customLabels').mapState;
export default Vue.extend({
    computed: {
        ...mapCustomLabelsState(['claimant']),
        ...mapState(['refNo', 'status', 'type', 'parentCategory', 'category', 'date']),
        ...mapGetters(['getFieldLabel', 'getAuthor']),
        ...grievanceFormGetters(['isFieldVisible']),
        ...mapRootState(['locale', 'portalBranding']),
        dateTimeString() {
            // Map 'no' to 'nb' for moment.js (Norwegian Bokmål)
            const momentLocale = this.locale === 'no' ? 'nb' : this.locale;
            moment.locale(momentLocale);
            return moment(this.date).format('LLL');
        },
    },
});
